// import React, { useContext, useEffect, useState } from "react";
// import axios from "axios";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";
// import { FaCheck, FaTimes, FaPlus, FaSearch, FaFilter } from "react-icons/fa";

// export default function Leave() {
//   const { user: currentUser } = useContext(AuthContext);
//   const [leaves, setLeaves] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("ALL");
//   const [typeFilter, setTypeFilter] = useState("ALL");
//   const [showFilters, setShowFilters] = useState(false);
//   const [activeTab, setActiveTab] = useState('EMPLOYEE_LEAVE');
//   const [showRemarkModal, setShowRemarkModal] = useState(false);
//   const [currentAction, setCurrentAction] = useState(null);
//   const [currentLeaveId, setCurrentLeaveId] = useState(null);
//   const [remark, setRemark] = useState("");
//   const [isProcessing, setIsProcessing] = useState(false);

//   const token = localStorage.getItem("token");
//   const headers = { Authorization: `Bearer ${token}` };
//   const companyId = currentUser?.accountType === "COMPANY" ? currentUser?.id : currentUser?.companyId;

//   // Leave types with colors
//   const leaveTypes = {
//     CASUAL: { color: "bg-blue-100 text-blue-800", label: "Casual" },
//     SICK: { color: "bg-red-100 text-red-800", label: "Sick" },
//     EARNED: { color: "bg-green-100 text-green-800", label: "Earned" },
//     MATERNITY: { color: "bg-purple-100 text-purple-800", label: "Maternity" },
//     PATERNITY: { color: "bg-pink-100 text-pink-800", label: "Paternity" },
//     OTHER: { color: "bg-yellow-100 text-yellow-800", label: "Other" }
//   };

//   // Format date to "MMM D" format (e.g. "Jun 1")
//   const formatShortDate = (dateString) => {
//     const date = new Date(dateString);
//     return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(date);
//   };

//   // Format date to "MMM D, YYYY" format (e.g. "Jun 1, 2023")
//   const formatLongDate = (dateString) => {
//     const date = new Date(dateString);
//     return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(date);
//   };

//   const fetchLeaves = async () => {
//     if (!currentUser?.id) return;
//     setLoading(true);
//     try {
//       let apiUrl;
      
//       if (currentUser.accountType === "COMPANY") {
//         apiUrl = `${API_URL}/api/leave/company/${currentUser?.id}`;
//       } else if (currentUser.accountType === "EXECUTIVE") {
//         apiUrl = `${API_URL}/api/leave/user/${currentUser.id}`;
//       } else {
//         if (activeTab === 'EMPLOYEE_LEAVE') {
//           apiUrl = `${API_URL}/api/leave/my-related/${currentUser.id}`;
//         } else {
//           apiUrl = `${API_URL}/api/leave/user/${currentUser.id}`;
//         }
//       }
      
//       const res = await axios.get(apiUrl, { headers });
//       setLeaves(res.data || []);
//     } catch (err) {
//       toast.error("Failed to fetch leave data");
//       console.error("Error fetching leaves:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeaves();
//   }, [currentUser, activeTab]);

//   const handleActionClick = (id, action) => {
//     setCurrentLeaveId(id);
//     setCurrentAction(action);
//     setShowRemarkModal(true);
//   };

//   const handleSubmitAction = async () => {
//   if (!currentLeaveId || !currentAction) {
//     toast.error("Leave ID or action is missing");
//     return;
//   }

//   setIsProcessing(true);
//   try {
//     await axios.put(
//       `${API_URL}/api/leave/company/${companyId}/${currentLeaveId}/status`,
//       {}, // Empty body since we're using params
//       { 
//         headers,
//         params: { // All data moved to params
//           status: currentAction,
//           approverId: currentUser.id,
//           approverName: currentUser.name,
//           remark: remark
//         }
//       }
//     );
//     toast.success(`Leave ${currentAction.toLowerCase()} successfully`);
//     fetchLeaves();
//     setShowRemarkModal(false);
//     setRemark("");
//   } catch (err) {
//     console.error("Error details:", {
//       url: `${API_URL}/api/leave/company/${companyId}/${currentLeaveId}/status`,
//       params: {
//         status: currentAction,
//         approverId: currentUser.id,
//         approverName: currentUser.name,
//         remark: remark
//       },
//       error: err.response?.data || err.message
//     });
//     toast.error(`Failed to ${currentAction.toLowerCase()} leave: ${err.response?.data?.message || err.message}`);
//   } finally {
//     setIsProcessing(false);
//   }
// };

//   // Filter leaves based on search and filters
//   const filteredLeaves = leaves.filter(leave => {
//     const matchesSearch = 
//       leave.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       leave.reason?.toLowerCase().includes(searchTerm.toLowerCase());
    
//     const matchesStatus = 
//       statusFilter === "ALL" || 
//       leave.status === statusFilter;
    
//     const matchesType = 
//       typeFilter === "ALL" || 
//       leave.leaveType === typeFilter;
    
//     return matchesSearch && matchesStatus && matchesType;
//   });

//   const formatDateRange = (fromDate, toDate) => {
//     const from = formatShortDate(fromDate);
//     const to = formatLongDate(toDate);
//     return `${from} - ${to}`;
//   };

//   const calculateDuration = (fromDate, toDate) => {
//     const start = new Date(fromDate);
//     const end = new Date(toDate);
//     const diffTime = Math.abs(end - start);
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//     return diffDays + 1;
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-4 md:p-8 dark:bg-gray-900">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="flex flex-col gap-4 mb-6">
//           <div>
//             <h1 className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
//               Leave Management
//             </h1>
//             <p className="text-gray-600 dark:text-gray-400">
//               {currentUser.accountType === "COMPANY" 
//                 ? "Company leave applications"
//                 : currentUser.accountType === "EXECUTIVE"
//                 ? "My leave applications"
//                 : "View and manage leave applications"}
//             </p>
//           </div>
          
//           <div className="flex flex-col sm:flex-row gap-3 w-full">
//             {!["COMPANY", "EXECUTIVE"].includes(currentUser.accountType) && (
//               <div className="flex border rounded-lg overflow-hidden dark:border-gray-700 w-full sm:w-auto">
//                 <button
//                   onClick={() => setActiveTab('EMPLOYEE_LEAVE')}
//                   className={`px-4 py-2 text-sm font-medium flex-1 ${
//                     activeTab === 'EMPLOYEE_LEAVE'
//                       ? 'bg-blue-500 text-white'
//                       : 'bg-white text-gray-700 hover:bg-gray-100 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700'
//                   }`}
//                 >
//                   Employee Leave
//                 </button>
//                 <button
//                   onClick={() => setActiveTab('MY_LEAVE')}
//                   className={`px-4 py-2 text-sm font-medium flex-1 ${
//                     activeTab === 'MY_LEAVE'
//                       ? 'bg-blue-500 text-white'
//                       : 'bg-white text-gray-700 hover:bg-gray-100 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700'
//                   }`}
//                 >
//                   My Leave
//                 </button>
//               </div>
//             )}
            
//             <div className="flex gap-3 w-full">
//               <button
//                 onClick={() => setShowFilters(!showFilters)}
//                 className="flex items-center gap-2 bg-white hover:bg-gray-100 text-gray-700 px-4 py-2 rounded-lg shadow border border-gray-200 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 flex-shrink-0"
//               >
//                 <FaFilter /> <span className="hidden sm:inline">Filters</span>
//               </button>
              
//               <div className="relative flex-grow">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                   <FaSearch className="text-gray-400" />
//                 </div>
//                 <input
//                   type="text"
//                   placeholder="Search leaves..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="pl-10 w-full p-2 border rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-white"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Filters Panel */}
//         {showFilters && (
//           <div className="bg-white p-4 rounded-lg shadow-md mb-6 dark:bg-gray-800">
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                   Status
//                 </label>
//                 <select
//                   value={statusFilter}
//                   onChange={(e) => setStatusFilter(e.target.value)}
//                   className="w-full p-2 border rounded-lg dark:bg-gray-700 dark:text-white dark:border-gray-600"
//                 >
//                   <option value="ALL">All Statuses</option>
//                   <option value="PENDING">Pending</option>
//                   <option value="APPROVED">Approved</option>
//                   <option value="REJECTED">Rejected</option>
//                 </select>
//               </div>
              
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                   Leave Type
//                 </label>
//                 <select
//                   value={typeFilter}
//                   onChange={(e) => setTypeFilter(e.target.value)}
//                   className="w-full p-2 border rounded-lg dark:bg-gray-700 dark:text-white dark:border-gray-600"
//                 >
//                   <option value="ALL">All Types</option>
//                   {Object.entries(leaveTypes).map(([type, { label }]) => (
//                     <option key={type} value={type}>{label}</option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Leaves Table */}
//         <div className="bg-white rounded-xl shadow-md overflow-hidden dark:bg-gray-800">
//           {loading ? (
//             <div className="p-8 text-center">
//               <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
//               <p className="mt-4 text-gray-600 dark:text-gray-400">Loading leaves...</p>
//             </div>
//           ) : filteredLeaves.length === 0 ? (
//             <div className="p-8 text-center">
//               <p className="text-gray-600 dark:text-gray-400">
//                 {leaves.length === 0 ? "No leave records found" : "No leaves match your filters"}
//               </p>
//             </div>
//           ) : (
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
//                 <thead className="bg-gray-50 dark:bg-gray-700">
//                   <tr>
//                     <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
//                       Employee
//                     </th>
//                     <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300 hidden sm:table-cell">
//                       Leave Type
//                     </th>
//                     <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300 hidden md:table-cell">
//                       Date Range
//                     </th>
//                     <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300 hidden lg:table-cell">
//                       Duration
//                     </th>
//                     <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300 hidden xl:table-cell">
//                       Reason
//                     </th>
//                     <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
//                       Status
//                     </th>
//                     {activeTab !== 'MY_LEAVE' && (
//                       <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
//                         Approve
//                       </th>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
//                   {filteredLeaves.map((leave) => (
//                     <tr key={leave.id} className="hover:bg-gray-50 dark:hover:bg-gray-700">
//                       <td className="px-3 py-4 whitespace-nowrap">
//                         <div className="flex items-center">
//                           <div className="flex-shrink-0 h-8 w-8 sm:h-10 sm:w-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold">
//                             {leave.username?.charAt(0) || "U"}
//                           </div>
//                           <div className="ml-2 sm:ml-4">
//                             <div className="text-sm font-medium text-gray-900 dark:text-white">
//                               {leave.username || "Unknown User"}
//                             </div>
//                             <div className="text-xs text-gray-500 dark:text-gray-400 sm:hidden">
//                               {leaveTypes[leave.leaveType]?.label || leave.leaveType}
//                             </div>
//                           </div>
//                         </div>
//                       </td>
//                       <td className="px-3 py-4 whitespace-nowrap hidden sm:table-cell">
//                         <span className={`px-2 py-1 text-xs font-semibold rounded-full ${leaveTypes[leave.leaveType]?.color || 'bg-gray-100 text-gray-800'}`}>
//                           {leaveTypes[leave.leaveType]?.label || leave.leaveType}
//                         </span>
//                       </td>
//                       <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400 hidden md:table-cell">
//                         {formatDateRange(leave.fromDate, leave.toDate)}
//                       </td>
//                       <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400 hidden lg:table-cell">
//                         {calculateDuration(leave.fromDate, leave.toDate)} day(s)
//                       </td>
//                       <td className="px-3 py-4 text-sm text-gray-500 dark:text-gray-400 hidden xl:table-cell">
//                         {leave.reason || "N/A"}
//                       </td>
//                       <td className="px-3 py-4 whitespace-nowrap">
//                         <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
//                           leave.status === "APPROVED" ? "bg-green-100 text-green-800" :
//                           leave.status === "REJECTED" ? "bg-red-100 text-red-800" :
//                           "bg-yellow-100 text-yellow-800"
//                         }`}>
//                           <span className="hidden sm:inline">{leave.status}</span>
//                           <span className="sm:hidden">{leave.status.charAt(0)}</span>
//                         </span>
//                       </td>
//                       {activeTab !== 'MY_LEAVE' && (
//                         <td className="px-3 py-4 whitespace-nowrap text-sm font-medium">
//                           {leave.status === "PENDING" ? (
//                             <div className="flex space-x-2">
//                               <button
//                                 onClick={() => handleActionClick(leave.id, "APPROVED")}
//                                 className="text-green-600 hover:text-green-900 dark:text-green-400 dark:hover:text-green-300"
//                                 title="Approve"
//                               >
//                                 <FaCheck size={16} />
//                               </button>
//                               <button
//                                 onClick={() => handleActionClick(leave.id, "REJECTED")}
//                                 className="text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300"
//                                 title="Reject"
//                               >
//                                 <FaTimes size={16} />
//                               </button>
//                             </div>
//                           ) : leave.approverName ? (
//                             <div className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
//                               <span className="hidden sm:inline">Approved by: </span>
//                               <span>{leave.approverName}</span>
//                             </div>
//                           ) : (
//                             <div className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 capitalize">
//                               {leave.status.toLowerCase()}
//                             </div>
//                           )}
//                         </td>
//                       )}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>

//         {/* Pagination */}
//         {filteredLeaves.length > 0 && (
//           <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-3 bg-white p-4 rounded-lg shadow dark:bg-gray-800">
//             <div className="text-sm text-gray-700 dark:text-gray-400">
//               Showing <span className="font-medium">1</span> to <span className="font-medium">{filteredLeaves.length}</span> of{' '}
//               <span className="font-medium">{filteredLeaves.length}</span> results
//             </div>
//             <div className="flex space-x-2">
//               <button
//                 disabled
//                 className="px-3 py-1 border rounded-md text-sm font-medium text-gray-500 bg-gray-100 dark:bg-gray-700 dark:text-gray-400 cursor-not-allowed"
//               >
//                 Previous
//               </button>
//               <button
//                 disabled
//                 className="px-3 py-1 border rounded-md text-sm font-medium text-gray-500 bg-gray-100 dark:bg-gray-700 dark:text-gray-400 cursor-not-allowed"
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Remark Modal */}
//         {showRemarkModal && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//             <div className="bg-white rounded-lg shadow-xl w-full max-w-md dark:bg-gray-800">
//               <div className="p-6">
//                 <div className="flex justify-between items-center mb-4">
//                   <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                     {currentAction === "APPROVED" ? "Approve Leave" : "Reject Leave"}
//                   </h3>
//                   <button
//                     onClick={() => {
//                       setShowRemarkModal(false);
//                       setRemark("");
//                     }}
//                     className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
//                   >
//                     <FaTimes />
//                   </button>
//                 </div>
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
//                     Remark
//                   </label>
//                   <textarea
//                     value={remark}
//                     onChange={(e) => setRemark(e.target.value)}
//                     className="w-full p-2 border rounded-lg dark:bg-gray-700 dark:text-white dark:border-gray-600"
//                     rows={3}
//                     placeholder="Enter your remark here..."
//                   />
//                 </div>
//                 <div className="flex justify-end space-x-3">
//                   <button
//                     onClick={() => {
//                       setShowRemarkModal(false);
//                       setRemark("");
//                     }}
//                     className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 dark:bg-gray-600 dark:text-white"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleSubmitAction}
//                     disabled={isProcessing}
//                     className={`px-4 py-2 text-sm font-medium text-white rounded-lg ${
//                       currentAction === "APPROVED" 
//                         ? "bg-green-600 hover:bg-green-700" 
//                         : "bg-red-600 hover:bg-red-700"
//                     } disabled:opacity-50`}
//                   >
//                     {isProcessing ? "Processing..." : currentAction}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }




import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { toast } from "react-toastify";
import { FaCheck, FaTimes, FaSearch, FaFilter } from "react-icons/fa";

export default function Leave() {
  const { user: currentUser } = useContext(AuthContext);
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [typeFilter, setTypeFilter] = useState("ALL");
  const [showFilters, setShowFilters] = useState(false);
  const [activeTab, setActiveTab] = useState('EMPLOYEE_LEAVE');
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [currentAction, setCurrentAction] = useState(null);
  const [currentLeaveId, setCurrentLeaveId] = useState(null);
  const [remark, setRemark] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const companyId = currentUser?.accountType === "COMPANY" ? currentUser?.id : currentUser?.companyId;

  // Leave types with colors
  const leaveTypes = {
    CASUAL: { color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300", label: "Casual" },
    SICK: { color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300", label: "Sick" },
    EARNED: { color: "bg-green-100 text-green-800 dark:bg-emerald-900/30 dark:text-emerald-300", label: "Earned" },
    MATERNITY: { color: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300", label: "Maternity" },
    PATERNITY: { color: "bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-300", label: "Paternity" },
    OTHER: { color: "bg-yellow-100 text-yellow-800 dark:bg-amber-900/30 dark:text-amber-300", label: "Other" }
  };

  const formatShortDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(date);
  };

  const formatLongDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(date);
  };

  const fetchLeaves = async () => {
    if (!currentUser?.id) return;
    setLoading(true);
    try {
      let apiUrl;
      
      if (currentUser.accountType === "COMPANY") {
        apiUrl = `${API_URL}/api/leave/company/${currentUser?.id}`;
      } else if (currentUser.accountType === "EXECUTIVE") {
        apiUrl = `${API_URL}/api/leave/user/${currentUser.id}`;
      } else {
        if (activeTab === 'EMPLOYEE_LEAVE') {
          apiUrl = `${API_URL}/api/leave/my-related/${currentUser.id}`;
        } else {
          apiUrl = `${API_URL}/api/leave/user/${currentUser.id}`;
        }
      }
      
      const res = await axios.get(apiUrl, { headers });
      setLeaves(res.data || []);
    } catch (err) {
      toast.error("Failed to fetch leave data");
      console.error("Error fetching leaves:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaves();
  }, [currentUser, activeTab]);

  const handleActionClick = (id, action) => {
    setCurrentLeaveId(id);
    setCurrentAction(action);
    setShowRemarkModal(true);
  };

  const handleSubmitAction = async () => {
    if (!currentLeaveId || !currentAction) {
      toast.error("Leave ID or action is missing");
      return;
    }

    setIsProcessing(true);
    try {
      await axios.put(
        `${API_URL}/api/leave/company/${companyId}/${currentLeaveId}/status`,
        {}, 
        { 
          headers,
          params: { 
            status: currentAction,
            approverId: currentUser.id,
            approverName: currentUser.name,
            remark: remark
          }
        }
      );
      toast.success(`Leave ${currentAction.toLowerCase()} successfully`);
      fetchLeaves();
      setShowRemarkModal(false);
      setRemark("");
    } catch (err) {
      console.error("Error details:", err);
      toast.error(`Failed to ${currentAction.toLowerCase()} leave: ${err.response?.data?.message || err.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  const filteredLeaves = leaves.filter(leave => {
    const matchesSearch = 
      leave.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      leave.reason?.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = 
      statusFilter === "ALL" || 
      leave.status === statusFilter;
    
    const matchesType = 
      typeFilter === "ALL" || 
      leave.leaveType === typeFilter;
    
    return matchesSearch && matchesStatus && matchesType;
  });

  const formatDateRange = (fromDate, toDate) => {
    const from = formatShortDate(fromDate);
    const to = formatLongDate(toDate);
    return `${from} - ${to}`;
  };

  const calculateDuration = (fromDate, toDate) => {
    const start = new Date(fromDate);
    const end = new Date(toDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays + 1;
  };

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
      
      <div className="min-h-screen bg-[#FAF8FF] p-4 md:p-8 dark:bg-gray-900 cfg-font shadow-lg rounded-lg">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="flex flex-col gap-5 mb-6">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold cfg-heading dark:text-white">
                Leave Management
              </h1>
              <p className="text-[#6B7280] dark:text-gray-400 mt-1 font-medium text-sm">
                {currentUser.accountType === "COMPANY" 
                  ? "Company leave applications"
                  : currentUser.accountType === "EXECUTIVE"
                  ? "My leave applications"
                  : "View and manage leave applications"}
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 w-full">
              {!["COMPANY", "EXECUTIVE"].includes(currentUser.accountType) && (
                <div className="flex border border-[#E5E7EB] rounded-lg overflow-hidden dark:border-gray-700 w-full sm:w-auto shadow-sm">
                  <button
                    onClick={() => setActiveTab('EMPLOYEE_LEAVE')}
                    className={`px-5 py-2.5 text-sm font-semibold flex-1 transition ${
                      activeTab === 'EMPLOYEE_LEAVE'
                        ? 'bg-[#673AB7] text-white'
                        : 'bg-white text-[#374151] hover:bg-[#F3F4F6] dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700'
                    }`}
                  >
                    Employee Leave
                  </button>
                  <button
                    onClick={() => setActiveTab('MY_LEAVE')}
                    className={`px-5 py-2.5 text-sm font-semibold flex-1 transition border-l border-[#E5E7EB] dark:border-gray-700 ${
                      activeTab === 'MY_LEAVE'
                        ? 'bg-[#673AB7] text-white'
                        : 'bg-white text-[#374151] hover:bg-[#F3F4F6] dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700'
                    }`}
                  >
                    My Leave
                  </button>
                </div>
              )}
              
              <div className="flex gap-3 w-full">
                <button
                  onClick={() => setShowFilters(!showFilters)}
                  className="flex items-center gap-2 bg-white hover:bg-[#F3F4F6] text-[#374151] px-4 py-2.5 rounded-lg shadow-sm border border-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-700 flex-shrink-0"
                >
                  <FaFilter className="text-[#6B7280] dark:text-gray-400" /> <span className="hidden sm:inline">Filters</span>
                </button>
                
                <div className="relative flex-grow shadow-sm rounded-lg">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                    <FaSearch className="text-[#9CA3AF]" />
                  </div>
                  <input
                    type="text"
                    placeholder="Search leaves..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 w-full p-2.5 border border-[#E5E7EB] rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition text-sm"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Filters Panel */}
          {showFilters && (
            <div className="bg-white p-5 rounded-xl shadow-sm border border-[#E5E7EB] mb-6 dark:bg-gray-800 dark:border-gray-700">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                    Status
                  </label>
                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:text-white dark:border-gray-600 text-sm transition"
                  >
                    <option value="ALL">All Statuses</option>
                    <option value="PENDING">Pending</option>
                    <option value="APPROVED">Approved</option>
                    <option value="REJECTED">Rejected</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                    Leave Type
                  </label>
                  <select
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                    className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:text-white dark:border-gray-600 text-sm transition"
                  >
                    <option value="ALL">All Types</option>
                    {Object.entries(leaveTypes).map(([type, { label }]) => (
                      <option key={type} value={type}>{label}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          )}

          {/* Leaves Table */}
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] overflow-hidden dark:bg-gray-800 dark:border-gray-700">
            {loading ? (
              <div className="p-10 text-center">
                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-[#673AB7] mx-auto"></div>
                <p className="mt-4 text-[#6B7280] font-medium dark:text-gray-400">Loading leaves...</p>
              </div>
            ) : filteredLeaves.length === 0 ? (
              <div className="p-10 text-center">
                <p className="text-[#6B7280] italic dark:text-gray-400">
                  {leaves.length === 0 ? "No leave records found." : "No leaves match your current filters."}
                </p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-[#E5E7EB] dark:divide-gray-700">
                  <thead className="bg-[#F3F4F6] dark:bg-gray-700">
                    <tr>
                      <th className="px-4 py-3.5 text-left text-xs font-bold text-[#6B7280] uppercase tracking-wider dark:text-gray-300">
                        Employee
                      </th>
                      <th className="px-4 py-3.5 text-left text-xs font-bold text-[#6B7280] uppercase tracking-wider dark:text-gray-300 hidden sm:table-cell">
                        Leave Type
                      </th>
                      <th className="px-4 py-3.5 text-left text-xs font-bold text-[#6B7280] uppercase tracking-wider dark:text-gray-300 hidden md:table-cell">
                        Date Range
                      </th>
                      <th className="px-4 py-3.5 text-left text-xs font-bold text-[#6B7280] uppercase tracking-wider dark:text-gray-300 hidden lg:table-cell">
                        Duration
                      </th>
                      <th className="px-4 py-3.5 text-left text-xs font-bold text-[#6B7280] uppercase tracking-wider dark:text-gray-300 hidden xl:table-cell">
                        Reason
                      </th>
                      <th className="px-4 py-3.5 text-left text-xs font-bold text-[#6B7280] uppercase tracking-wider dark:text-gray-300">
                        Status
                      </th>
                      {activeTab !== 'MY_LEAVE' && (
                        <th className="px-4 py-3.5 text-left text-xs font-bold text-[#6B7280] uppercase tracking-wider dark:text-gray-300">
                          Approve
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-[#E5E7EB] dark:bg-gray-800 dark:divide-gray-700">
                    {filteredLeaves.map((leave) => (
                      <tr key={leave.id} className="hover:bg-[#FAF8FF] dark:hover:bg-gray-700 transition-colors">
                        <td className="px-4 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="flex-shrink-0 h-9 w-9 bg-[#F3E8FF] border border-[#E9D5FF] dark:bg-purple-900/50 dark:border-purple-800 rounded-full flex items-center justify-center text-[#673AB7] dark:text-[#E9D5FF] font-bold shadow-sm">
                              {leave.username?.charAt(0).toUpperCase() || "U"}
                            </div>
                            <div className="ml-3">
                              <div className="text-sm font-bold text-[#1F2937] dark:text-white">
                                {leave.username || "Unknown User"}
                              </div>
                              <div className="text-xs text-[#6B7280] dark:text-gray-400 sm:hidden mt-0.5">
                                {leaveTypes[leave.leaveType]?.label || leave.leaveType}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap hidden sm:table-cell">
                          <span className={`px-2.5 py-1 text-xs font-bold rounded-md border ${
                            leaveTypes[leave.leaveType] ? 
                            (leave.leaveType === 'CASUAL' ? 'bg-[#DBEAFE] text-[#1D4ED8] border-[#BFDBFE] dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800' :
                             leave.leaveType === 'SICK' ? 'bg-[#FEE2E2] text-[#B91C1C] border-[#FECACA] dark:bg-red-900/30 dark:text-red-300 dark:border-red-800' :
                             leave.leaveType === 'EARNED' ? 'bg-[#D1FAE5] text-[#047857] border-[#A7F3D0] dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800' :
                             leave.leaveType === 'MATERNITY' ? 'bg-[#F3E8FF] text-[#673AB7] border-[#E9D5FF] dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-800' :
                             leave.leaveType === 'PATERNITY' ? 'bg-[#FCE7F3] text-[#BE185D] border-[#FBCFE8] dark:bg-pink-900/30 dark:text-pink-300 dark:border-pink-800' :
                             'bg-[#FEF3C7] text-[#B45309] border-[#FDE68A] dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800') 
                            : 'bg-[#F3F4F6] text-[#374151] border-[#E5E7EB] dark:bg-gray-700 dark:text-gray-300'
                          }`}>
                            {leaveTypes[leave.leaveType]?.label || leave.leaveType}
                          </span>
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-[#4B5563] dark:text-gray-300 hidden md:table-cell">
                          {formatDateRange(leave.fromDate, leave.toDate)}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm font-bold text-[#374151] dark:text-gray-200 hidden lg:table-cell">
                          {calculateDuration(leave.fromDate, leave.toDate)} day(s)
                        </td>
                        <td className="px-4 py-4 text-sm text-[#4B5563] dark:text-gray-300 hidden xl:table-cell max-w-[200px] truncate">
                          {leave.reason || "N/A"}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap">
                          <span className={`px-2.5 py-1 text-xs font-bold rounded-md border ${
                            leave.status === "APPROVED" ? "bg-[#D1FAE5] text-[#047857] border-[#A7F3D0] dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800" :
                            leave.status === "REJECTED" ? "bg-[#FEE2E2] text-[#B91C1C] border-[#FECACA] dark:bg-red-900/30 dark:text-red-300 dark:border-red-800" :
                            "bg-[#FEF3C7] text-[#B45309] border-[#FDE68A] dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800"
                          }`}>
                            <span className="hidden sm:inline">{leave.status}</span>
                            <span className="sm:hidden">{leave.status.charAt(0)}</span>
                          </span>
                        </td>
                        {activeTab !== 'MY_LEAVE' && (
                          <td className="px-4 py-4 whitespace-nowrap text-sm font-medium">
                            {leave.status === "PENDING" ? (
                              <div className="flex space-x-2">
                                <button
                                  onClick={() => handleActionClick(leave.id, "APPROVED")}
                                  className="text-[#10B981] hover:text-[#059669] bg-[#D1FAE5] hover:bg-[#A7F3D0] p-1.5 rounded-md dark:bg-emerald-900/30 dark:text-emerald-400 dark:hover:bg-emerald-900/50 transition"
                                  title="Approve"
                                >
                                  <FaCheck size={14} />
                                </button>
                                <button
                                  onClick={() => handleActionClick(leave.id, "REJECTED")}
                                  className="text-[#EF4444] hover:text-[#B91C1C] bg-[#FEF2F2] hover:bg-[#FECACA] p-1.5 rounded-md dark:bg-red-900/30 dark:text-red-400 dark:hover:bg-red-900/50 transition"
                                  title="Reject"
                                >
                                  <FaTimes size={14} />
                                </button>
                              </div>
                            ) : leave.approverName ? (
                              <div className="text-xs text-[#6B7280] dark:text-gray-400 font-medium">
                                <span className="hidden sm:inline">By: </span>
                                <span>{leave.approverName}</span>
                              </div>
                            ) : (
                              <div className="text-xs text-[#6B7280] dark:text-gray-400 capitalize font-medium">
                                {leave.status.toLowerCase()}
                              </div>
                            )}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Pagination */}
          {filteredLeaves.length > 0 && (
            <div className="flex flex-col sm:flex-row justify-between items-center gap-3 bg-white p-4 rounded-xl shadow-sm border border-[#E5E7EB] dark:bg-gray-800 dark:border-gray-700">
              <div className="text-sm text-[#4B5563] dark:text-gray-400 font-medium">
                Showing <span className="font-bold text-[#1F2937] dark:text-white">1</span> to <span className="font-bold text-[#1F2937] dark:text-white">{filteredLeaves.length}</span> of{' '}
                <span className="font-bold text-[#1F2937] dark:text-white">{filteredLeaves.length}</span> results
              </div>
              <div className="flex gap-2">
                <button
                  disabled
                  className="px-3 py-1.5 border border-[#E5E7EB] rounded-md text-sm font-semibold text-[#9CA3AF] bg-[#F3F4F6] dark:bg-gray-700 dark:border-gray-600 dark:text-gray-500 cursor-not-allowed"
                >
                  Previous
                </button>
                <button
                  disabled
                  className="px-3 py-1.5 border border-[#E5E7EB] rounded-md text-sm font-semibold text-[#9CA3AF] bg-[#F3F4F6] dark:bg-gray-700 dark:border-gray-600 dark:text-gray-500 cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>
          )}

          {/* Remark Modal */}
          {showRemarkModal && (
            <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-xl shadow-2xl w-full max-w-md dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-700">
                <div className="p-6">
                  <div className="flex justify-between items-center mb-5 border-b border-[#E5E7EB] dark:border-gray-700 pb-3">
                    <h3 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">
                      {currentAction === "APPROVED" ? "Approve Leave" : "Reject Leave"}
                    </h3>
                    <button
                      onClick={() => {
                        setShowRemarkModal(false);
                        setRemark("");
                      }}
                      className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 transition"
                    >
                      <FaTimes className="w-5 h-5" />
                    </button>
                  </div>
                  <div className="mb-5">
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-2">
                      Remark <span className="text-[#6B7280] font-normal italic">(optional)</span>
                    </label>
                    <textarea
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      className="w-full p-3 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:text-white dark:border-gray-600 text-sm"
                      rows={3}
                      placeholder="Enter your remark here..."
                    />
                  </div>
                  <div className="flex justify-end gap-3 pt-2">
                    <button
                      onClick={() => {
                        setShowRemarkModal(false);
                        setRemark("");
                      }}
                      className="px-4 py-2 text-sm font-semibold text-[#374151] bg-[#F3F4F6] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmitAction}
                      disabled={isProcessing}
                      className={`px-5 py-2 text-sm font-bold text-white rounded-md shadow-sm transition ${
                        currentAction === "APPROVED" 
                          ? "bg-[#10B981] hover:bg-[#059669]" 
                          : "bg-[#EF4444] hover:bg-[#B91C1C]"
                      } disabled:opacity-50`}
                    >
                      {isProcessing ? "Processing..." : currentAction}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}